/* eslint-disable no-unused-vars */
import Vue from "vue";
import VueRouter from "vue-router";
import RegistrationView from "../views/RegistrationView.vue";
import NotFoundView from "../views/NotFoundView.vue";
import ConfirmationView from "../views/ConfirmationView.vue";

Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        name: "home",
        component: RegistrationView,
        props: route => ({ token: route.query.t }),
    },
    {
        path: "/confirmation",
        name: "done",
        component: ConfirmationView,
    },
    {
        path: "/404-not-found",
        name: "404",
        component: NotFoundView,
    },
    {
        path: "*",
        redirect: { name: "404" },
    },
];

const router = new VueRouter({
    mode: "history",
    base: __dirname,
    routes,
    scrollBehavior(to, from, savedPosition) {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve(
                    to.hash && to.hash != "#"
                        ? {
                            selector: to.hash,
                            offset: { x: 0, y: 0 },
                            behavior: "smooth",
                        }
                        : { x: 0, y: 0 }
                );
            }, 250);
        });
    },
});

export default router;
